module.exports = __webpack_public_path__ + "img/locked-padlock.1c7f872c.svg";